import {Trans, useTranslation} from '@/translations/i18n'
import {ModalBody, ModalCloseButton, ModalFooter, ModalHeader} from '@components/ui/modal-atoms'
import {Dialog, DialogClose, DialogContent} from '@components/ui/dialog'
import {ConfirmAccountSection} from '@features/user/components/confirm-account-section'
import {Button} from '@components/ui/button'
import {usePhotographersSsoLogout} from '@features/user/queries/usePhotographersSsoLogout'
import {Spinner} from '@components/ui/spinner'
import {FC} from 'react'
import {usePhotographersSsoConfigured} from '@features/user/queries/usePhotographersSsoConfigured'
import {useMe} from '@features/user/queries/useMe'

interface ConfirmAccountModalProps {
    onClose: () => void
    handleOpenChangeAccount: () => void
}

export const ConfirmAccountModal: FC<ConfirmAccountModalProps> = ({onClose, handleOpenChangeAccount}) => {
    const {t} = useTranslation()
    const meQuery = useMe()
    const photographersSsoLogoutMutation = usePhotographersSsoLogout({
        onSuccess: () => {
            onClose()
            handleOpenChangeAccount()
        }
    })

    const photographersSsoConfiguredMutation = usePhotographersSsoConfigured({
        onSuccess: () => {
            onClose()
        }
    })

    return (
        <Dialog open={true} onOpenChange={onClose}>
            <DialogContent
                className="w-[546px] grid grid-rows-[auto_minmax(0,1fr)_auto] overflow-hidden"
                showCloseButton={false}
            >
                <ModalHeader className="py-2.5 px-2 border-none">
                    <DialogClose data-slot="dialog-close" render={<ModalCloseButton />} />
                </ModalHeader>
                <ModalBody>
                    <ConfirmAccountSection />

                    <p className="text-center text-md text-black [&_b]:text-md [&_b]:font-medium [&_b]:text-black">
                        <Trans i18nKey="link_airbnb_account:sign_in_description" components={{b: <b />}} />
                    </p>
                </ModalBody>

                <ModalFooter>
                    <Button
                        variant="tertiary"
                        shape="text"
                        onClick={() => photographersSsoLogoutMutation.mutate()}
                        disabled={photographersSsoLogoutMutation.isPending}
                    >
                        {t('commons:cancel')}
                        {photographersSsoLogoutMutation.isPending && <Spinner />}
                    </Button>
                    <Button
                        onClick={
                            meQuery.data?.isAirbnbSsoConfigured
                                ? () => onClose()
                                : () => photographersSsoConfiguredMutation.mutate()
                        }
                        disabled={photographersSsoLogoutMutation.isPending}
                    >
                        {t('commons:confirm')}
                    </Button>
                </ModalFooter>
            </DialogContent>
        </Dialog>
    )
}
ConfirmAccountModal.displayName = 'ConfirmAccountModal'
